module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/home-ownership.svg?27ed0a7fdee10de1fdfae0bde4834e00";